import { SupplierRelationshipGetResponseType } from "@sellar-io/api-v2/types";
import { useCreditTermsText } from "./useCreditTermsText";

export type AllOtherPaymentOptionsType = Array<
  | {
      value: "credit";
      pretty: string;
    }
  | {
      value: "proforma";
      pretty: string;
    }
  | {
      value: "paymentOnDelivery";
      pretty: string;
    }
>;

export const useAllOtherPaymentOptions = ({
  connection,
}: {
  connection:
    | Pick<
        SupplierRelationshipGetResponseType,
        "paymentTerms" | "paymentDueCalculateFrom" | "paymentDue"
      >
    | null
    | undefined;
}): AllOtherPaymentOptionsType => {
  const _allPaymentOptions = new Set<
    "proforma" | "credit" | "paymentOnDelivery"
  >();

  const creditTermsText = useCreditTermsText({ connection });

  // default payment method, always supported, even if connection does not exist
  _allPaymentOptions.add("proforma");

  if (connection?.paymentTerms) {
    _allPaymentOptions.add(connection.paymentTerms);
  }

  return [..._allPaymentOptions].map((po) => {
    switch (po) {
      case "credit": {
        return {
          value: po,
          pretty: creditTermsText,
        };
      }
      case "proforma": {
        return {
          value: po,
          pretty: "Pro-forma",
        };
      }
      case "paymentOnDelivery": {
        return {
          value: po,
          pretty: "Payment on delivery",
        };
      }
    }
  });
};
